module.exports = __webpack_public_path__ + "img/it.191d4ea4.svg";